import {SimpleIconButton} from "../../../misc/lists/SimpleIconButton";
import Clear from "@mui/icons-material/Clear";
import {RouteStopGroup} from "../../../api/Logistics";
import {api} from "../../../api/API";
import {useSnackbar} from "../../../misc/Snackbar";
import {RefreshRouteItems} from "./RouteItems";
import {routePopupPanel} from "./RouteList";
import {Completed} from "./Completed";
import {AuditLogIconPopper} from "./AuditLogIconPopper";

export function CustomTextGroupRow(props: {
    value: RouteStopGroup;
    routeCompleted: boolean;
}) {
    const snack = useSnackbar();

    return (
        <tr>
            <td>
                {props.value.customTextGroup || "<missing>"}
            </td>
            <td>
                <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                    <AuditLogIconPopper group={props.value.id} />
                </div>
            </td>
            <td>
                <Completed contents={props.value.items || []} routeComplete={props.routeCompleted} complete={props.value.completed} />
            </td>
            <td style={{display: "flex", justifyContent: "flex-end"}}>
                <div className="actions">
                    <SimpleIconButton disabled={props.value.completed} onClick={async () => {
                        try {

                            await api.logistics.upsertStopGroup(Object.assign({}, props.value, {
                                archived: true,
                            }))

                        } catch (e: any) {
                            snack.error(e.toString())
                            return;
                        }

                        RefreshRouteItems.emit({
                            updatedByUs: true,
                        });
                        routePopupPanel.sendToClient("refresh-to-move")
                        snack.success("Updated")
                    }}>
                        <Clear />
                    </SimpleIconButton>
                </div>
            </td>
        </tr>
    )
}